import React from 'react';
import { Desktop, Mobile } from 'app/components/Responsive';
import CloseCross from './subtract.component.svg';
import CloseCrossDesktop from './img/CloceDesktop.component.svg';
import css from './inviteFriendsBanner.module.scss';

export const CloseButtonCross = (props) => {
    const { onClick, modifier = 'default' } = props;
    return (
        <button
            onClick={onClick}
            type="button"
            className={`${css.closeButtonCrossRoot} ${css[modifier]}`}
        >
            <Mobile>
                <CloseCross />
            </Mobile>
            <Desktop>
                <CloseCrossDesktop />
            </Desktop>
        </button>
    );
};
